import React from 'react';

import { CheckedIcon } from 'assets/images';

import styles from './FinalStep.module.scss';

const FinalStep = () => {
  return (
    <div className={styles.finalStepWrapper}>
      <CheckedIcon className={styles.checkedIcon} />
      <p className={styles.text}>Thank you for answering ID verification questions!</p>
    </div>
  );
};

export default FinalStep;
